import { render, staticRenderFns } from "./ShortenTextCell.vue?vue&type=template&id=358637f2&"
import script from "./ShortenTextCell.vue?vue&type=script&lang=babel&"
export * from "./ShortenTextCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports